import {call, put, take} from 'redux-saga/effects';

import {BannerApi} from 'static/three-oh/src/modules/apis';

import * as actions from './../actions/bannerActions';
import * as types from './../constants/bannerActionTypes';

function * getBanners() {
  try {
    const data = yield call(BannerApi.getBanners);
    yield put(actions.requestBannerSuccess(data));
  } catch (error) {
    yield put(actions.requestBannerFailure(error));
  }
}

export function * watchGetBanners() {
  yield take(types.BANNER_LOAD_REQUEST);
  yield call(getBanners);
}

function * dismissBanner(data) {
  try {
    yield call(BannerApi.saveUserBanner, data);
  } catch (error) {
    // TODO: have a legit error message
  }
}

export function * watchBannerDismissal() {
  const action = yield take(types.BANNER_DISMISSAL_POST);
  yield call(dismissBanner, action);
}
